export const SCREEN_DESIGN_SIZE = {
  WIDTH: 430,
  HEIGHT: 932,
  get ASPECT_RATIO() {
    return this.WIDTH / this.HEIGHT;
  },
} as const;

export type ScreenDesignSize = typeof SCREEN_DESIGN_SIZE;
